import { NotificationType } from '../enums/NotificationId';
import { NotificationLevel } from '../enums/NotificationLevel';

export const notificationLevelMap = {
  [NotificationType.DRIP_CHAMBER_DETACHED]: NotificationLevel.ERROR,
  [NotificationType.THERAPY_JOB_UNPAIRED_FROM_MD]: NotificationLevel.INFO,
  [NotificationType.PENDING_CONFIRMATION_INFO]: NotificationLevel.INFO,
  [NotificationType.PENDING_CONFIRMATION_WARNING]: NotificationLevel.WARN,
  [NotificationType.THERAPY_JOB_ABORT_TRIGGERED]: NotificationLevel.ERROR,
  [NotificationType.VOLUME_TOO_HIGH]: NotificationLevel.WARN,
  [NotificationType.NO_VOLUME_PROVIDED]: NotificationLevel.WARN,
  [NotificationType.FLOW_RATE_TOO_FAST]: NotificationLevel.WARN,
  [NotificationType.FLOW_RATE_TOO_SLOW]: NotificationLevel.WARN,
  [NotificationType.THERAPY_JOB_UPDATED]: NotificationLevel.INFO,
  [NotificationType.THERAPY_JOB_ON_HOLD]: NotificationLevel.ERROR,
  [NotificationType.THERAPY_JOB_CANCELLED]: NotificationLevel.ERROR,
  [NotificationType.THERAPY_JOB_STOPPED]: NotificationLevel.ERROR,
  [NotificationType.THERAPY_JOB_ENTERED_IN_ERROR]: NotificationLevel.ERROR,
  [NotificationType.THERAPY_JOB_MARK_FOR_DELETION]: NotificationLevel.ERROR,
  [NotificationType.DEVICE_DISCONNECTED]: NotificationLevel.WARN,
  [NotificationType.PATIENT_DISCHARGED]: NotificationLevel.ERROR,
  [NotificationType.PATIENT_NOT_ADMITTED]: NotificationLevel.ERROR,
  [NotificationType.INFUSION_IN_ERROR]: NotificationLevel.ERROR
};

export const notificationActionMap = {
  [NotificationType.NO_VOLUME_PROVIDED]: 'NotificationNoVolumeProvidedActionButton',
  [NotificationType.THERAPY_JOB_UPDATED]: 'AcknowledgeChangesPanelActionButtonUpdated',
  // Abort button
  [NotificationType.THERAPY_JOB_CANCELLED]: 'AcknowledgeChangesPanelActionButtonDeleted',
  [NotificationType.THERAPY_JOB_STOPPED]: 'AcknowledgeChangesPanelActionButtonDeleted',
  [NotificationType.THERAPY_JOB_MARK_FOR_DELETION]: 'AcknowledgeChangesPanelActionButtonDeleted'
};
